import { useState } from "react";
import axiosInstance from "@/hooks/axios";
import { isAxiosError } from "axios";

export interface ChangePasswordData {
  old_password: string;
  new_password: string;
  confirm_password: string;
}

export interface ChangePasswordResponse {
  success: boolean;
  message: string;
}

export const useChangePassword = () => {
  const [data, setData] = useState<ChangePasswordResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const changePassword = async (passwordData: ChangePasswordData) => {
    setLoading(true);
    setError(null);

    const authToken = localStorage.getItem("authToken");
    if (!authToken) {
      setError("Not authenticated.");
      setLoading(false);
      return;
    }

    try {
      const response = await axiosInstance.post<ChangePasswordResponse>(
        "users/users/change_password/",
        passwordData,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        },
      );
      setData(response.data);
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        setError(err.message);
      } else if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("An unknown error occurred.");
      }
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, changePassword };
};
